import { render } from "./hrm-position-modal.vue?vue&type=template&id=3637f3dd"
import script from "./hrm-position-modal.vue?vue&type=script&lang=js"
export * from "./hrm-position-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__